import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import ReaderDetail from '@/components/screens/reader-detail/ReaderDetail';
import { API_URL, BOOKS_FOR_PAGE } from '@/helpers/variables';

import { IReaderDetail } from '@/interfaces/readerDetail.interface';

interface IAuthorDetailPageDynamicProps {
  reader: IReaderDetail;
}

const ReaderDetailPageDynamic: NextPage<IAuthorDetailPageDynamicProps> = ({ reader }) => {
  return <ReaderDetail reader={reader} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { id } = context.query;

  const res = await fetch(`${API_URL}satellite/person/${id}?page=1&page_size=${BOOKS_FOR_PAGE}`);

  // Check fetch error
  if (!res.ok) {
    console.table(`Error ${res.status}. Api: ${res.url}`);
    return {
      notFound: true,
    };
  }

  const reader = await res.json();

  // Check Fetched Data Error
  if (!reader.person_books_count) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      reader,
    },
  };
};

export default ReaderDetailPageDynamic;
